import styled from "styled-components"
import { ListGroup } from "react-bootstrap"

export const Product = styled(ListGroup)`
  position: relative;
  display: flex;
  margin-bottom: 0.5rem;
  padding: 1rem;
  border: 1px solid var(--reeler-grey);
  &:hover {
    border: 1px solid var(--reeler-grey-darker);
  }
`

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 600px;
`
export const ProductName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
export const ProductDescription = styled.p`
  font-size: 0.75rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ProductButtonContainer = styled.span``
export const ProductButton = styled.a`
  background: #000;
  color: #fff;
  padding: 0.25rem 1rem;
  text-align: center;
  text-decoration: none;

  &:hover {
    color: #fff;
    background: #878787;
    text-decoration: none;
  }
`

export const ProductImageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 30px;
  height: 30px;
`
export const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
